import React from 'react';

import { Button } from 'react-bootstrap';

import Glyphicon from '../../components/app-icon';

import { createMarkupForLabel } from '../../utils/utils';
import {
	getPropertyLabelTargetAnchorForLabel,
	normalizePanelKey
} from '../../utils/propertyPanelUtils';

import AfPropDescription from "./afPropDescription";

function getTextFromReactNode(node) {
	if (node === null || node === undefined || typeof node === "boolean") {
		return "";
	}
	if (typeof node === "string" || typeof node === "number") {
		return String(node);
	}
	if (Array.isArray(node)) {
		return node.map(getTextFromReactNode).join(" ");
	}
	if (React.isValidElement(node)) {
		return getTextFromReactNode(node.props.children);
	}
	return "";
}

function getFirstChildText(children) {
	return React.Children.toArray(children)
		.map((child) => getTextFromReactNode(child).replace(/\s+/g, " ").trim())
		.find(Boolean) || "";
}

class AfHelp extends React.PureComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			showDescription: false
		}

		this.containerRef = null;
	}

	componentDidMount() {
		this.updatePropertyAnchorAttributes();
	}

	componentDidUpdate() {
		this.updatePropertyAnchorAttributes();
	}

	getPropertyLabelText() {
		return this.props.propertyLabel || this.props.propertyKey || getFirstChildText(this.props.children);
	}

	updatePropertyAnchorAttributes() {
		if (!this.containerRef || !this.containerRef.setAttribute) {
			return;
		}

		const propertyLabelText = this.getPropertyLabelText();
		const propertyLabelKey = normalizePanelKey(propertyLabelText);
		const propertyTargetAnchor = this.props.propertyAnchor || getPropertyLabelTargetAnchorForLabel(propertyLabelText);
		if (!propertyLabelKey || !propertyTargetAnchor) {
			this.containerRef.removeAttribute("data-property-panel-target-anchor");
			this.containerRef.removeAttribute("data-property-panel-label-key");
			this.containerRef.removeAttribute("data-property-panel-label");
			return;
		}

		this.containerRef.setAttribute("data-property-panel-target-anchor", propertyTargetAnchor);
		this.containerRef.setAttribute("data-property-panel-label-key", propertyLabelKey);
		this.containerRef.setAttribute("data-property-panel-label", propertyLabelText);
	}

	render() {
		let description;
		if (typeof this.props.description === "string") {
			description = <div dangerouslySetInnerHTML={createMarkupForLabel(this.props.description)} />
		} else {
			description = <AfPropDescription description={this.props.description} learnMoreLinks={this.props.learnMoreLinks} />;
		}

		const question =
			<div onClick={(e) => { this.setState({ showDescription: !this.state.showDescription }) }}>
				<Glyphicon style={{ marginLeft: "5px", fontSize: "16px", color: "darkgreen" }} glyph='question-circle' />
			</div>;

		return (
			<div ref={(node) => { this.containerRef = node; }} style={{ width: "100%" }}>
				<div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
					<div style={{ display: "flex", alignItems: this.props.alignItems ? this.props.alignItems : "flex-start" }}>
						{this.props.children}
						{question}
					</div>
					{this.props.hasOwnProperty("extraComponents") &&
						this.props.extraComponents
					}
				</div>
				{this.state.showDescription &&
					<div className="disable-select" style={{ marginBottom: "10px", backgroundColor: "skyblue", padding: "10px", borderRadius: "10px", overflow: "auto" }}>
						{description}
						<Button style={{ marginTop: "15px", backgroundColor: "darkblue", borderColor: "darkblue", color: "white" }} onClick={() => { this.setState({ showDescription: false }) }}>Close</Button>
					</div>
				}
			</div>
		);
	}
}

export default AfHelp;
